import {
  ChangeDetectorRef,
  Component,
  NgZone,
  OnDestroy,
  ViewChild,
  HostListener,
  Directive,
  AfterViewInit,
  OnInit,
} from '@angular/core';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { MediaMatcher } from '@angular/cdk/layout';

import { MenuItems } from '../../../shared/menu-items/menu-items';
import { DialogService } from '../../../shared/dialog/dialog.service';
import { Router } from '@angular/router';
import { DialogChangePwdComponent } from '../../../shared/dialog/dialog-changepwd.component';
import { AlertsService, AlterIndicatorTypes } from '../../../shared/alerts/alerts.service';
import { takeUntil } from 'rxjs/operators';
import { Subject, Observable } from 'rxjs';
import { MessageBrokerService } from '../../../shared/broker/message-broker.service';
import { BrokerTopics } from '../../../shared/broker/broker-topics.enum';
import { UserService } from '../../../users/users.service';
import { AuctionService } from '../../../auction/auction.service';
import { Auction } from '../../../auction/auction.model';
import { MatSelectChange } from '@angular/material/select';
import { LoginService } from '../../../login/login.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: [],
})
export class AppSidebarComponent implements OnInit, OnDestroy {
  public config: PerfectScrollbarConfigInterface = {};
  mobileQuery: MediaQueryList;

  private _mobileQueryListener: () => void;
  status: boolean = true;

  itemSelect: number[] = [];
  parentIndex: Number;
  childIndex: Number;

  userRacketRequestNum = 0;
  auctionList$ = this.auctionService.getAll();
  selectedAuction: Auction;
  currentUserName$: Observable<string>;

  private $subsDisposal = new Subject<void>();

  setClickedRow(i, j) {
    this.parentIndex = i;
    this.childIndex = j;
  }
  subclickEvent() {
    this.status = true;
  }
  scrollToTop() {
    document.querySelector('.page-wrapper').scroll({
      top: 0,
      left: 0,
    });
  }

  constructor(
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    public menuItems: MenuItems,
    private auctionService: AuctionService,
    private loginService: LoginService,
    private userService: UserService,
    private dialog: DialogService,
    private routes: Router,
    private alertService: AlertsService,
    private messageBrokerService: MessageBrokerService,
  ) {
    this.mobileQuery = media.matchMedia('(min-width: 768px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
    this.currentUserName$ = this.loginService.getCurrentUserName();
  }

  ngOnInit(): void {
    this.alertService
      .listenIndicator(AlterIndicatorTypes.USER_REQUESTS)
      .pipe(takeUntil(this.$subsDisposal))
      .subscribe((values: any) => {
        if (values && values.count) {
          if (values.count === 0 || values.count > this.userRacketRequestNum) {
            this.messageBrokerService.publish(BrokerTopics.USER_REQUEST_CHANGED, { count: values.count });
          }
          this.userRacketRequestNum = values.count;
        } else {
          this.userRacketRequestNum = 0;
        }
      });

    this.auctionService.getCurrent().subscribe((auction: Auction) => {
      if (auction) {
        console.log('auction current:', auction);
        this.selectedAuction = auction;
      }
    });
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
    this.$subsDisposal.next();
    this.$subsDisposal.complete();
  }

  onAuctionChanged(selection: MatSelectChange) {
    const auction = selection.value as Auction;
    this.auctionService.changeCurrent(auction);
  }

  logout() {
    this.loginService.logout().then(() => this.routes.navigate(['/login']));
  }

  changePwd() {
    this.dialog.host.open(DialogChangePwdComponent, {
      disableClose: true,
      width: '500px',
    });
  }
}
